<template>
  <div class="public-history-container" v-if="parameter.visable">
    <el-dialog :visible.sync="parameter.visable" title="历史" :width="['report','dataSourceReport'].some(n=>n===this.parameter.type)?'670px':'458px'" center :close-on-click-modal="false">
      <div class="dialog-content">
        <div class="table">
          <el-table :data="tableData" v-loading="loading" height="100%" header-row-class-name="header-class">
            <el-table-column prop="createUser"
                             label="修改人"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="createTime"
                             label="修改时间"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="comment"
                             label="备注"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center">
            <template slot-scope="scope">
              <el-button v-show="scope.row.id!==firstDataId" type="text" @click="goVersion(scope.row)">回退</el-button>
            </template>
          </el-table-column>
          </el-table>
        </div>
        <div class="hint">只显示最近30条修改记录</div>
      </div>
      <span slot="footer">
        <el-button @click="parameter.visable = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
export default {
  props: ['parameter'],
  name: 'public-history',
  data () {
    return {
      tableData: [],
      loading: true,
      firstDataId: ''
    }
  },
  methods: {
    loadList (url) {
      this.$axios.get(`${url}historys/${this.parameter.id}`).then(res => {
        this.tableData = res.data || []
        this.firstDataId = this.tableData[this.tableData.length - 1].id
        this.tableData[this.tableData.length - 1].comment = ''
      })
    },
    goVersion (row) {
      this.$confirm('', '你确定要回退吗?', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'publishMessageBox',
        center: true
      })
        .then(() => {
          this.copyLoading = Loading.service({
            lock: false,
            text: '回退中, 请稍等...',
            customClass: 'loading',
            spinner: '',
            background: 'rgba(0, 0, 0, 0.4)'
          })
          let type = this.parameter.type
          let url = type === 'process' ? '/process-api/processes/backup/' : type === 'form' ? '/form-api/defines/backup/' : '/report-api/report/definition/backup/'
          this.$axios.get(`${url}${row.id}`)
            .then((res) => {
              let backUpReport = JSON.parse(res.data.modelJson)
              if (type === 'process') {
                backUpReport.definition.comment = `回退至${row.createTime}的版本`
              } else {
                backUpReport.comment = `回退至${row.createTime}的版本`
              }
              let definitionUrl = type === 'process' ? '/process-api/processes' : type === 'form' ? '/form-api/defines' : '/report-api/report/definition'
              return this.$axios.post(definitionUrl, backUpReport)
            })
            .then((res) => {
              this.copyLoading.close()
              this.$message.success('回退成功')
              this.parameter.visable = false
            })
            .catch(() => {
              this.copyLoading.close()
              this.$message.error('回退失败')
              this.parameter.visable = false
            })
        })
        .catch(() => {

        })
    }
  },
  watch: {
    'parameter.visable' (val) {
      if (val) {
        let type = this.parameter.type
        // 默认报表
        let url = type === 'report' || type === 'dataSourceReport' ? `/report-api/report/definition/` : type === 'process' ? '/process-api/processes/' : '/form-api/defines/'
        try {
          this.loadList(url)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .public-history-container {
    & > .el-dialog__wrapper {
      .el-dialog {
        .el-dialog__body {
          padding: 20px 20px 0 20px;
        }

        .dialog-content {
          & > .table {
            height: 215px;

            .el-table__header {
              border-bottom: 1px solid #EBEBEB;
            }

            .header-class {
              th {
                background-color: #fff;
              }
            }
          }

          .hint {
            text-align: center;
            color: #A0A3A8;
            padding: 33px 0 18px 0;
            font-size: 11px;
          }
        }

        .el-dialog__footer {
          padding: 0 0 16px 0;

          .el-button {
            width:84px;
            height:26px;
            border:1px solid #54ABF1;
            border-radius:4px;
            color: #54ABF1;
            padding: 0;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/public-history.vue